<template>
  <div class="empty-data">
    {{ $t("emptyData") }}
  </div>
</template>

<script>
export default {};
</script>
